<template>
    <v-container fluid fill-height>
        <v-card  outlined width="100%" class="fill-height">
            <v-card-text class="pa-5">
                <v-row>
                    <v-col cols=6 md=6 lg=6 sm=6>
                        <v-chip label color="amber" large> <v-icon left>mdi-history</v-icon>Entry History</v-chip>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols=12 md=12 lg=12 sm=12>
                        <v-data-table :headers="headers" :items="records" class="tablefontsize"></v-data-table>
                    </v-col>
                </v-row> 
            </v-card-text>           
        </v-card>
        <v-snackbar v-model="notificationBar" top center :color="notificationColor" multi-line> {{ notificationText }}
            <v-btn color="amber" text @click="notificationBar = false"> Close </v-btn>
        </v-snackbar>
    </v-container>
</template>
<script>
import { SERVER_API } from '../../API';
export default {
    mounted(){
        this.fetchall();
    },
    data(){
        return{
            headers:[
                { text: 'Product Name', value: 'productName' },
                { text: 'Product Nature', value: 'productNature' },
                { text: 'Product Condition', value: 'productCondition' },
                { text:'Cond / PP', value: 'maxRate'},
                { text:'Non Cond / Jute', value: 'minRate'},
                { text:'Loose Rate', value: 'singleRate'},
                { text:'PP EX', value: 'maxExRate'},
                { text:'PP FOR', value: 'maxForRate'},
                { text:'Jute EX', value: 'minExRate'},
                { text:'Jute FOR', value: 'minForRate'},
                { text:'Credit Day', value: 'maxDay'},
                { text:'Interest', value: 'rateOfInterest'},
                { text:'by', value: 'createdBy'},
                { text:'update At', value: 'CreatedAt'},
            ],
            records:[],

            // Notification Setting
            notificationColor: 'black',
            notificationBar: false,
            notificationText:''
        }
    },
    methods:{
        async fetchall(){
            const response =  await this.$http.get(SERVER_API+'/dailyupdate/records');
            this.records = response.data.data;
        },
        action(e){
            if(e.action == true){
                this.notificationColor = 'black';
                this.notificationBar = true;
                this.notificationText = e.message;
                this.fetchall();
                this.CreateBox = false;
            }else{
                this.notificationColor = 'red';
                this.notificationBar = true;
                this.notificationText = e.message;
                //console.log(e);
            }

        }
    }

}
</script>

<style>
.tablefontsize .v-data-table__wrapper table tbody tr td{
    font-size: 10px !important;
}
.tablefontsize .v-data-table__wrapper table thead tr th{
    font-size: 10px !important;
    font-weight: bold;
    color:#000;
}
</style>